import { DropFileError } from '@isyc-react/form-file/modules/drop-file/drop-status';
import { nsnewo } from "../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
const RejectedFileError = props => {
  const {
    file,
    error
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  switch (error.code) {
    case DropFileError.TOO_MANY_FILES:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('newo.dropFileError.tooManyFiles'));
    case DropFileError.INVALID_TYPE:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('newo.dropFileError.invalid'));
    case DropFileError.TOO_LARGE:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('newo.dropFileError.tooLarge'));
    case DropFileError.TOO_SMALL:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('newo.dropFileError.tooSmall'));
    default:
      return /*#__PURE__*/React.createElement("small", {
        className: "text-danger"
      }, t('newo.dropFileError.error'));
  }
};
export const RejectedFile = props => {
  const {
    rejected
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row text-xl-start align-items-center pb-2 pb-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "justify-content-center justify-content-xl-start align-items-center pb-2 pb-xl-0 invalidate"
  }, rejected.map((rejection, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: i
  }, /*#__PURE__*/React.createElement("span", null, rejection.file.name), /*#__PURE__*/React.createElement("br", null), rejection.errors.map((error, j) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: j
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(RejectedFileError, {
    file: rejection.file,
    error: error
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "filebox col-xl-8 text-center pt-md-5 pt-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6 text-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-cloud-upload mdi-48px text-secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-6 text-start"
  }, /*#__PURE__*/React.createElement("span", null, t('newo.documentalValidation.dropText1'), /*#__PURE__*/React.createElement("br", null), t('newo.documentalValidation.dropText2')))))));
};